export default {
  home: "الرئيسية",
  explore: "استكشف",
  bookings: "الحجوزات",
  profile: "الملف الشخصي",
  dashboard: "لوحة التحكم",
  messages: "الرسائل",
  earnings: "الأرباح",

  signOut: "تسجيل الخروج",
  save: "حفظ",
  cancel: "إلغاء",
  back: "رجوع",
  loading: "جاري التحميل...",
  submit: "إرسال",
  online: "متصل",
  offline: "غير متصل",

  welcomeBack: "مرحباً بعودتك",
  elevateSpace: "ارتقِ بمساحتك مع موناً.",
  discovery: "الاكتشاف",
  curatedServices: "خدمات مختارة",
  allCategories: "جميع الفئات",
  activeAssignments: "المهام النشطة",

  findArtisan: "ابحث عن حرفيك.",
  startingFrom: "يبدأ من",
  bookNow: "احجز الآن",
  proVerified: "محترف موثق",

  myBookings: "حجوزاتي",
  pending: "قيد الانتظار",
  confirmed: "مؤكد",
  completed: "مكتمل",
  help: "مساعدة",

  professionalDashboard: "لوحة تحكم المحترف",
  newLeads: "عملاء جدد",
  accept: "قبول",
  decline: "رفض",
  totalEarnings: "إجمالي الأرباح",
  leadPricing: "تسعير العملاء",
  myPublicProfile: "ملفي العام",
  portfolio: "معرض الأعمال",
  supportTickets: "تذاكر الدعم",

  requestQuote: "طلب عرض سعر",
  jobSize: "حجم العمل",
  describeJob: "صف عملك",
  serviceAddress: "عنوان الخدمة",
  preferredDate: "التاريخ والوقت المفضل",
  sendQuoteRequest: "إرسال الطلب",
  privateNotes: "ملاحظات خاصة للمحترف (اختياري)",
  addPhotos: "إضافة صور أو فيديو (اختياري)",

  howCanWeHelp: "كيف يمكننا مساعدتك؟",
  modifyBooking: "تعديل الحجز",
  cancelBooking: "إلغاء الحجز",
  messageProvider: "مراسلة مقدم الخدمة",
  issueWithService: "مشكلة في الخدمة",
  billingIssue: "مشكلة في الفاتورة",

  signIn: "تسجيل الدخول",
  signUp: "إنشاء حساب",
  email: "البريد الإلكتروني",
  password: "كلمة المرور",
  noAccount: "ليس لديك حساب؟ سجل",
  haveAccount: "لديك حساب؟ سجل دخولك",

  leaveReview: "اترك تقييماً",
  submitReview: "إرسال التقييم",
  respond: "رد",

  contactSupport: "تواصل مع الدعم",
  myTickets: "تذاكر الدعم الخاصة بي",
  getHelp: "الحصول على مساعدة",
};
